module.exports = __webpack_public_path__ + "static/media/img5.001bc330.jpg";